import React from "react";
import Sections from "./Sections";
const  EditProfileAdmin = ({ isEditMode, handleChange, values, setFieldValue, errors }) => {
   const fields = [
      {
         sectionName: "Personal information",
         propertyName: "Name",
         name: "name",
         propertyValue: values?.name,
         isEditMode: isEditMode,
         handleChange: handleChange,
         isRequired: true
      },
      {
         sectionName: "",
         propertyName: "Phone number",
         name: "phoneNumber",
         fieldType: "phone",
         propertyValue: values?.phoneNumber,
         isEditMode: isEditMode,
         onSelectChange: (value) => {
            setFieldValue("phoneNumber", value);
         },
         isRequired: true
      }
   ];

   return (
      <>
         {fields?.map((section, index) => (
            <div key={index}>
               <Sections {...section} />
               {errors[section.name] && <div className="text-danger">{errors[section.name]}</div>}
            </div>
         ))}
      </>
   );
};

export default EditProfileAdmin;
